module.exports = __webpack_public_path__ + "static/media/8import-20.9fa1b840.xlsx";